/**
 * The class the `dark` Tailwind variant matches (see `components/styles/design-system.css`).
 *
 * This is the whole colour-scheme API. There is deliberately no provider, no stored preference and
 * no `prefers-color-scheme` handling: which surfaces are dark is a design decision taken per page
 * or per region, not something the user toggles. Put this class on whatever ancestor bounds the
 * dark region and every DS component beneath it follows, because the variant matches `.dark *`.
 */
export const DARK_CLASS = 'dark';
